<ng-container *ngIf="sourceText">
    <p *ngFor="let p of split" [ngClass]="className">{{p}}</p>
</ng-container>